import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import * as Sentry from '@sentry/vue';
import { httpClientIntegration } from "@sentry/integrations";
import '../public/follow';

import interceptorsSetup from "./helpers/interceptor";
import RateTab from '@/views/on_table/RateExpMenu/RateTab';

interceptorsSetup();
Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.component('RateTab', RateTab);

if (process.env.NODE_ENV === 'production' && Math.floor(Math.random()*100) <= 5 ){
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_ENV,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      httpClientIntegration(),
    ],
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    allowUrls: [
      /^https:\/\/.+\.cluvi\.co[^a-z0-9]?.*$/,
      /^https:\/\/.+\.vue-testing\.cluvi-dev\.link[^a-z0-9]?.*$/,
      /^https:\/\/.+\.vue-pre-produccion\.cluvi-dev\.link[^a-z0-9]?.*$/,
    ],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
